module.exports = __webpack_public_path__ + "static/media/iconMapMarker.5a0ae09a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMapMarker.svg
// module id = 1123
// module chunks = 0